import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';

/** Google Analytics (GA) access function */
declare const ga: any;

/**
 * Service responsible for managing the analytics (events tracking) of the application.
 * This implementation uses Google Analytics (GA).
 *
 * @since 1.0.0
 */
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  /**
   * Emits a page to be tracked by GA.
   *
   * @public
   * @static
   * @since 1.0.0
   *
   * @param url  Page URL
   */
  public static trackPage(url: string): void {
    ga('set', 'page', url);
    ga('send', 'pageview');
  }

  /**
   * Emits an event to be tracked by GA.
   *
   * @public
   * @static
   * @since 1.0.0
   *
   * @param category  Event category
   * @param action    Event action
   * @param label     Event label
   * @param value     Event value
   */
  public static trackEvent(category: string, action: string, label?: string, value?: number): void {
    ga('send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: null || label,
      eventValue: null || value
    });
  }

  /**
   * Initializes the GA tracking service, by indicating the appropriate environment tracking ID.
   *
   * @public
   * @static
   * @since 1.0.0
   */
  public init(): void {
    ga('create', environment.analytics.ga, 'auto');
  }
}
